<template>
    <a class="avp-contact-link" :href="emailLink">{{ $t('generic.support.email') }}</a>
</template>

<script>
    export default {
        name: 'CustomerServiceEmail',
        computed: {
          emailLink() {
            return 'mailto:' + this.$i18n.t( 'generic.support.email' );
          }
        },
    }
</script>

